import script from "./DiagnosticTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiagnosticTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./DiagnosticTemplate.vue?vue&type=style&index=0&id=52cccfe8&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52cccfe8"]])

export default __exports__